import axios from 'axios'


async function register(login,set_setting,dispatch,data,setOpen,setMessage,add_test,add_tests,setLoading,navigate){
try{

    const regist = await axios.post(`${process.env.REACT_APP_SERVER_URL}register/`,data).catch(err=>{console.log(err)})

    if (regist?.status == 200 && regist?.data.success) {

    const usr = {
      accessToken:regist?.data.accessToken,
      refreshToken:regist?.data.refreshToken,
      auth:false,
      email:regist?.data.user.email,
      nationality:regist?.data.user?.nationality,
      birthday:regist?.data.user?.birthday,
      sex:regist?.data.user?.sex,
      tel:regist?.data.user?.tel,
      position:regist?.data.user?.position,
      address:regist?.data.user?.address,
      idCard:regist?.data.user?.idCard,
      cardType:regist?.data.user?.cardType,
      card:regist?.data.user?.card,
      cv:regist?.data.user?.cv,
      isVerified:regist?.data.user?.isVerified,
      isUserVerified:regist?.data.user?.isUserVerified,
      organization:regist?.data?.user?.organization,
      tests:regist?.data.user.tests,
      jobs:regist?.data.user?.jobs,
      isPremiumExpired:regist?.data.user.isPremiumExpired,
      plan:regist?.data.user.plan,
      profile:regist?.data.user.picture,
      roomId:"",
      last_name:regist?.data.user.last_name,
      first_name:regist?.data.user.first_name,
      totalTest:regist?.data.user.totalTest,
      totalTraining:regist?.data.user.totalTraining
    }

    await dispatch(login(usr));
    await dispatch(add_tests(regist?.data?.user.tests))
    dispatch(set_setting({
      apiKey:regist?.data?.user?.ApiKey,
      lang:regist?.data?.user?.lang
    }))

    await localStorage.setItem("iTestUser",JSON.stringify(usr))
    
    setMessage("welcome to iTest platform")
    setOpen(true)
    navigate("/verify")
    setLoading(false)

    }else{
      setLoading(false)
      setMessage(regist?.data?.message)
      setOpen(true)
    }
  }catch(err){
    console.log(err)
  }
}

export default register